import React from "react";
import { Video, BookOpen, Users, MessageCircle, Sparkles, ArrowRight } from "lucide-react";
import { programItems, quantumLevels, RESERVE_URL } from "../mock";

const ICONS = { Video, BookOpen, Users, MessageCircle, Sparkles };

export default function Program() {
  return (
    <section id="programme" className="relative py-20 md:py-28">
      <div className="relative mx-auto max-w-7xl px-5">
        <div className="text-center reveal max-w-3xl mx-auto">
          <span className="kicker">Un programme concret &amp; structuré</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            Pour te guider sur ton{" "}
            <span className="gold-gradient-text">chemin</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {programItems.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <div
                key={p.title}
                className={`reveal glass card-hover rounded-3xl p-8 ${
                  i === programItems.length - 1 ? "lg:col-span-1 md:col-span-2" : ""
                }`}
              >
                <span className="grid place-items-center h-12 w-12 rounded-2xl bg-[#e8c874]/12 text-gold">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="font-display text-xl text-white mt-5">{p.title}</h3>
                <p className="text-white/60 text-sm mt-2 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>

        {/* Quantum levels */}
        <div className="mt-24">
          <div className="text-center reveal max-w-3xl mx-auto">
            <span className="kicker">Passe au niveau quantique</span>
            <h2 className="font-display text-3xl md:text-4xl font-semibold text-white mt-3">
              Si tu as le sentiment de stagner, il est temps de plonger plus profond
            </h2>
          </div>
          <div className="mt-12 grid md:grid-cols-3 gap-6">
            {quantumLevels.map((q) => (
              <div key={q.title} className="reveal group rounded-3xl overflow-hidden border border-white/10 card-hover">
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={q.img}
                    alt={q.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#041824] via-[#041824]/30 to-transparent" />
                </div>
                <div className="p-6 bg-white/[0.03]">
                  <h3 className="font-display text-xl text-white">{q.title}</h3>
                  <p className="text-white/60 text-sm mt-2">{q.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-10 text-center reveal">
            <a href={RESERVE_URL} target="_blank" rel="noreferrer"
               className="btn-gold px-7 py-4 inline-flex items-center gap-2">
              Je veux vivre cette transformation
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
